module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14.001",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#close",
      toString: function () {
        return this.url;
      }
    }